import script from "./TopicPdf.vue?vue&type=script&setup=true&lang=js"
export * from "./TopicPdf.vue?vue&type=script&setup=true&lang=js"

import "./TopicPdf.vue?vue&type=style&index=0&id=c71167de&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c71167de"]])

export default __exports__